type InviteStatus = "enviado" | "aceito" | "negado" | "cancelado";

interface InviteStatusConfig {
    label: string;
    colorClass: string;
    textStyle: string;
}

const STATUS_CONFIG: Record<InviteStatus, InviteStatusConfig> = {
    enviado: { label: "Pendente", colorClass: "text-warning-600", textStyle: "font-semibold" },
    aceito: { label: "Aceito", colorClass: "text-success-500", textStyle: "font-normal" },
    negado: { label: "Negado", colorClass: "text-danger-500", textStyle: "font-normal opacity-50" },
    cancelado: { label: "Cancelado", colorClass: "text-secondary-500", textStyle: "font-normal" },
};

const getConfig = (status: string | undefined): InviteStatusConfig | undefined =>
    status ? STATUS_CONFIG[status as InviteStatus] : undefined;

/** Returns the display label for an invite status. */
export const getInviteStatusLabel = (status: string | undefined): string =>
    getConfig(status)?.label ?? status ?? "-";

/** Returns a Tailwind text color class based on the invite status. */
export const getInviteStatusColorClass = (status: string | undefined): string =>
    getConfig(status)?.colorClass ?? "";

/** Returns Tailwind font/opacity classes based on the invite status. */
export const getInviteStatusTextStyle = (status: string | undefined): string =>
    getConfig(status)?.textStyle ?? "font-normal";
